import optimized from './optimizedImages.json';

const availableWidths = optimized as Record<string, number[]>;

export type ResponsiveImage = {
  src: string;
  srcSet: string;
};

/**
 * Builds src/srcSet pairs for images generated by `npm run optimize-images`.
 * Only widths present in the generated manifest are listed, so nothing 404s.
 * `fallback` is the original JPEG in /public, used if WebP fails.
 */
export const responsiveImage = (name: string, fallback: string): ResponsiveImage => {
  const widths = availableWidths[name] ?? [];
  return {
    src: fallback,
    srcSet: widths.map((w) => `/optimized/${name}-${w}.webp ${w}w`).join(', '),
  };
};

export const photos = {
  kitchen: responsiveImage('kitchen', '/Kitchen.jpeg'),
  bathroom: responsiveImage('bathroom', '/Bathroom.jpeg'),
  outdoor: responsiveImage('outdoor', '/outdoor.jpeg'),
  garden: responsiveImage('garden', '/Garden.jpeg'),
  bathroom2: responsiveImage('bathroom-2', '/Bathroom2.jpeg'),
  roof2: responsiveImage('roof-2', '/Roof2.jpeg'),
  kitchenIsland: responsiveImage('kitchen-island', '/Kitchen Island.jpeg'),
  kitchenStove: responsiveImage('kitchen-stove', '/Kitchen Stove.jpeg'),
  bathroom3: responsiveImage('bathroom-3', '/bathroom3.jpeg'),
  bathroom4: responsiveImage('bathroom-4', '/bathroom4.jpeg'),
  outdoor2: responsiveImage('outdoor-2', '/outdoor2.jpeg'),
  roof: responsiveImage('roof', '/Roof.jpeg'),
  roof2Angle: responsiveImage('roof-2-angle', '/Roof2angle.jpeg'),
  shower: responsiveImage('shower', '/Shower.jpeg'),
  kitchenSink: responsiveImage('kitchen-sink', '/kitchensink.jpeg'),
  kitchenVentilation: responsiveImage('kitchen-ventilation', '/kitchenventilation.jpeg'),
  wardrobe: responsiveImage('wardrobe', '/wardrobe.jpeg'),
  corridor: responsiveImage('corridor', '/corridor.jpeg'),
  doors: responsiveImage('doors', '/Doors.jpeg'),
  windows: responsiveImage('windows', '/windows.jpeg'),
};

export type PhotoKey = keyof typeof photos;
